import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerSupplierParams, TypePostOwnerSupplierResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 공급사 정보 등록
 */
const usePostOwnerSupplier = () => {
  const endPoint = '/api-owner/owner-supplier';

  const postOwnerSupplier = async (params: TypePostOwnerSupplierParams) => {
    return axiosInstance
      .post<TypePostOwnerSupplierResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOwnerSupplier };
};

export default usePostOwnerSupplier;
